import Vue from 'vue'
import {TOKEN} from "@/shared/enums/TokenSeparator";
import moment from 'moment';
import {DATE_FORMAT} from "@/shared/enums/DateFormats";

const upperCaseFirstLetter = (text) => {
    text = text.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
};

const addressFormatted = (addressObj) => {
    if(typeof addressObj === 'string') {
        addressObj = JSON.parse(addressObj);
    }

    let finalString = [];
    for(let key in addressObj)
    {
        if(addressObj[key] != '')
        {
            finalString.push(addressObj[key]);
        }
    }

    return finalString.join(', ');
};

const formatDate = (date, formatOut = DATE_FORMAT.LOCALE) => {
    return moment(date).format(formatOut);
};

Vue.filter('upperCaseFirstLetter', upperCaseFirstLetter);
Vue.filter('addressFormatted', addressFormatted);
Vue.filter('formatDate', formatDate);

export default {}

